import { MarketView } from './types';

// Groups views by parentCode (top level keyed by null), each group sorted by its own
// displayOrder — displayOrder is only meaningful WITHIN one sibling group, never across the
// whole tree. Shared by perps-v1-views/List.tsx (the Navigation tree table) and
// perps-v1-pins/viewTree.ts's flattenViewTree (the pins view picker).
//
// A view whose declared parentCode doesn't match any code in this same `views` set — because
// the parent doesn't exist, was filtered out before calling this (e.g. disabled), or was never
// there in the first place — is grouped under top level instead of under its stale parentCode.
// Keying it under a parent that isn't present would bucket it somewhere no consumer ever reads
// (nothing walks down from a code that isn't in the tree), so it would silently vanish from
// whichever screen called this. Promoting it to top level keeps it visible, editable and
// deletable instead.
export function buildChildrenByParent(views: MarketView[]): Map<string | null, MarketView[]> {
  const byOrder = (a: MarketView, b: MarketView) => a.displayOrder - b.displayOrder;
  const codes = new Set(views.map((v) => v.code));
  const map = new Map<string | null, MarketView[]>();
  views.forEach((v) => {
    const key = v.parentCode && codes.has(v.parentCode) ? v.parentCode : null;
    const list = map.get(key);
    if (list) {
      list.push(v);
    } else {
      map.set(key, [v]);
    }
  });
  map.forEach((list) => list.sort(byOrder));
  return map;
}
